import { Input, Label, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

function SeccionNacimiento({
  formik,
  country,
  province,
  poblationBirthFiltered,
  handleBirthProvinceChange,
}) {
  return (
    <Row className="mt-2">
      <Col md="2">
        <Label htmlFor="paisNacimiento">
          <small>
            País de nacimiento <span className="text-danger">*</span>
          </small>
        </Label>
        <Input
          id="paisNacimiento"
          name="paisNacimiento"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.paisNacimiento}
          className={formik.errors.paisNacimiento ? 'border border-danger error' : ''}
        >
          {country !== ''
            ? country.map((option) => (
                <option key={`${option.idcodi_pais}-nac`} value={option.nom}>
                  {option.nom}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.paisNacimiento ? (
          <div className="text-danger tiny">{formik.errors.paisNacimiento}</div>
        ) : null}
      </Col>
      <Col md="2">
        <Label htmlFor="provinciaNacimiento">
          <small>
            Provincia de nacimiento{' '}
            {formik.values.paisNacimiento !== 'España' ? (
              ''
            ) : (
              <span className="text-danger">*</span>
            )}
          </small>
        </Label>
        <Input
          id="provinciaNacimiento"
          name="provinciaNacimiento"
          type="select"
          onChange={handleBirthProvinceChange}
          value={formik.values.provinciaNacimiento}
          className={formik.errors.provinciaNacimiento ? 'border border-danger error' : ''}
          disabled={formik.values.paisNacimiento !== 'España' ? 'disabled' : ''}
        >
          {province !== ''
            ? province.map((option) => (
                <option key={`${option.provincia}-nac`} value={option.provincia}>
                  {option.provincia}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.provinciaNacimiento ? (
          <div className="text-danger tiny">{formik.errors.provinciaNacimiento}</div>
        ) : null}
      </Col>
      <Col md="3">
        <Label htmlFor="municipioNacimiento">
          <small>
            Municipio de nacimiento{' '}
            {formik.values.paisNacimiento !== 'España' ? (
              ''
            ) : (
              <span className="text-danger">*</span>
            )}
          </small>
        </Label>
        <Input
          id="municipioNacimiento"
          name="municipioNacimiento"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.municipioNacimiento}
          className={formik.errors.municipioNacimiento ? 'border border-danger error' : ''}
          disabled={formik.values.paisNacimiento !== 'España' ? 'disabled' : ''}
        >
          {poblationBirthFiltered !== ''
            ? poblationBirthFiltered.map((option) => (
                <option key={`${option.nom_municipi}-nac`} value={option.nom_municipi}>
                  {option.nom_municipi}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.municipioNacimiento ? (
          <div className="text-danger tiny">{formik.errors.municipioNacimiento}</div>
        ) : null}
      </Col>
      <Col md="2">
        <Label htmlFor="nacionalidad">
          <small>
            Nacionalidad <span className="text-danger">*</span>
          </small>
        </Label>
        <Input
          id="nacionalidad"
          name="nacionalidad"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.nacionalidad}
          className={formik.errors.nacionalidad ? 'border border-danger error' : ''}
        />
        {formik.errors.nacionalidad ? (
          <div className="text-danger tiny">{formik.errors.nacionalidad}</div>
        ) : null}
      </Col>
      <Col md="3">
        <Label htmlFor="nss">
          <small>Núm. Seguridad Social</small>
        </Label>
        <Input
          id="nss"
          name="nss"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.nss}
          className={formik.errors.nss ? 'border border-danger error' : ''}
        />
        {formik.errors.nss ? (
          <div className="text-danger tiny">{formik.errors.nss}</div>
        ) : null}
      </Col>
    </Row>
  );
}

SeccionNacimiento.propTypes = {
  formik: PropTypes.object.isRequired,
  country: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  province: PropTypes.array.isRequired,
  poblationBirthFiltered: PropTypes.array.isRequired,
  handleBirthProvinceChange: PropTypes.func.isRequired,
};

export default SeccionNacimiento;
